import { useEffect, useState } from "react";
import api from "./api";

// Loads the product catalogue with automatic retries and a visible error state,
// so a backend hiccup (e.g. during a publish) never leaves the page stuck on
// "LOADING THE DROP…" forever.
export function useProducts() {
  const [products, setProducts] = useState([]);
  const [state, setState] = useState("loading"); // loading | ready | error
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let alive = true;
    setState("loading");
    const backoffs = [0, 900, 2200];
    (async () => {
      for (const delay of backoffs) {
        if (delay) await new Promise((r) => setTimeout(r, delay));
        try {
          const { data } = await api.get("/products");
          if (!alive) return;
          setProducts(data);
          setState("ready");
          return;
        } catch (e) { /* retry */ }
      }
      if (alive) setState("error");
    })();
    return () => { alive = false; };
  }, [attempt]);

  return { products, state, retry: () => setAttempt((a) => a + 1) };
}
